import { InvoiceLinesBus } from "./InvoiceLinesBus";
import { CommonFunctions } from "../static/common-functions";
import { GeographyInfoBus } from "./GeographyInfoBus";
import { CommonValues } from "../static/CommonValues";
import { BaseInvBus } from "./BaseInvBus";
import { DateFunctions } from "../static/date-functions";

export class InvoiceBus extends BaseInvBus
{
    CID(): any {
        return this.invoiceId;
    }
    constructor(data: InvoiceBus = null) {
        super(data);
    }
    initialize(data: InvoiceBus) {
        super.initialize(data);
        try {
            this.invoiceDate = CommonFunctions.getDate(data.invoiceDate);
            this.oldDate = CommonFunctions.getDate(data.oldDate);
            this.commissionDate = CommonFunctions.getDate(data.commissionDate);
            this.minProfitOverrideDt = CommonFunctions.getDate(data.minProfitOverrideDt);
            this.sageDt = CommonFunctions.getDate(data.sageDt);
        }
        catch {

        }

    }

    setFromForm(data: InvoiceBus) {
        super.setFromForm(data);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.invoiceDate = date;
        this.invoiceStatusId = CommonValues.Invoice_Pending;
        this.accountClassId = CommonValues.AccountClass_ReferService;
    }

    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    get showQuoteNumberOnLineItems(): boolean {
        return CommonFunctions.hasValue(this.quoteId);
    }
    setBeforeSave() {
        super.setBeforeSave();
        this.invoiceDate = DateFunctions.getDateWithUTCOffset(this.invoiceDate);
        this.oldDate = DateFunctions.getDateWithUTCOffset(this.oldDate);
        this.commissionDate = DateFunctions.getDateWithUTCOffset(this.commissionDate);
        this.minProfitOverrideDt = DateFunctions.getDateWithUTCOffset(this.minProfitOverrideDt);

        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
    }
    invoiceId: any;
    invoiceStatusId: any;
    salespersonId: any;
    billingGeographyId: any;
    shippingGeographyId: any;
    quoteId: any;
    dispatchId: any;
    invoiceDate: Date;
    invoiceNumber: string;
    ponumber: string;
    invoiceDesc: string;
    qbid: string;
    qbEditSequenceId: string;
    wonumber: string;
    vendorNumber: string;
    oldDate: Date;
    commissionDate: Date;
    commissionAmount: number;
    pooverrideUserId: any;
    minProfitOverrideUserId: any;
    minProfitOverrideDt: Date;
    sageDt: Date;
    isDraw: boolean;
    setDispatchStatusToBilled: boolean;
    disputeStatus: number;
    creditMemoStatusId: any;
    creditMemoReasonCodeId: any;
    creditMemoReason: string;
    creditMemoRejectedReason: string;
    creditMemoAmount: number;
    invoiceLines: InvoiceLinesBus[];  
    shippingGeographyInfo: GeographyInfoBus;
    billingGeographyInfo: GeographyInfoBus;
    showDispatchNumberOnLineItems: boolean;
    amNote: string;
    isWarranty: any;
    isProgressBilling: boolean;
    isAvalaraError: boolean;
    orderBillId: string;
    orderBillReferenceNumber: string;
    vendorCreditReferenceNumber: string;
}
